export const projectName = 'pirabet'
export const projectStyledName = 'Pirabet.cash'
export const projectDomainName = 'pirabet.cash'
export const projectKey = 'pirabetcash'

export const projectNotificationName = 'pirabet.cash'
export const staticServerDomain = 'gcatg.com'

export const altenarBetHistoryUrl = 'https://dobets365.com/bet-history-frame'
export const newBCraftServicesUrl = 'https://new.bcraftservices.com'
export const sliderUrl = 'https://gcatg.com/services/content'
export const sliderImageBaseUrl = 'https://images.gcatg.com/media'

export const defaultCurrency = 'PYG'

export const defaultDateFormat = 'DD.MM.YYYY'
export const defaultTimeFormat = 'HH:mm:ss'
export const defaultViewDateFormat = `${defaultTimeFormat} ${defaultDateFormat}`

export const PRAGMATIC_DGA_WS_URL = 'dga.pragmaticplaylive.net'

export const PRAGMATIC_DGA_CASINO_ID = 'ppcdh00000006107'

export const altenarScriptId = 'altenar-script'

export const betbyScriptId = 'betby-script'
